import { render, staticRenderFns } from "./enter-email-verification-code.vue?vue&type=template&id=1acf6522&scoped=true"
import script from "./enter-email-verification-code.vue?vue&type=script&setup=true&lang=ts"
export * from "./enter-email-verification-code.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./enter-email-verification-code.vue?vue&type=style&index=0&id=1acf6522&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1acf6522",
  null
  
)

export default component.exports